(function () {
  'use strict';

  function initWelcomeVideoPlayer(container) {
    if (!container) return;
    const video = container.querySelector('video');
    if (!video) return;

    const playPauseBtn = container.querySelector('[data-video-play-btn]');
    const centerPlayBtn = container.querySelector('[data-video-play-center]');
    const timeCurrent = container.querySelector('[data-video-time-current]');
    const timeDuration = container.querySelector('[data-video-time-duration]');
    const scrubber = container.querySelector('[data-video-scrubber]');
    const progressFill = container.querySelector('[data-video-progress]');
    const progressThumb = container.querySelector('[data-video-thumb]');
    const volumeBtn = container.querySelector('[data-video-volume-btn]');
    const fullscreenBtn = container.querySelector('[data-video-fullscreen-btn]');

    function formatTime(seconds) {
      if (!seconds || isNaN(seconds) || seconds < 0) return '0:00';
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    function togglePlay() {
      if (video.paused || video.ended) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePlay();
      });
    }

    if (centerPlayBtn) {
      centerPlayBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePlay();
      });
    }

    // Clicking on video area outside control buttons toggles play/pause
    container.addEventListener('click', (e) => {
      if (e.target.closest('[data-video-controls]')) return;
      togglePlay();
    });

    video.addEventListener('play', () => {
      container.classList.add('is-playing');
      resetIdleTimer();
    });

    video.addEventListener('pause', () => {
      container.classList.remove('is-playing');
      container.classList.remove('controls-hidden');
    });

    video.addEventListener('ended', () => {
      container.classList.remove('is-playing');
      container.classList.remove('controls-hidden');
    });

    video.addEventListener('loadedmetadata', () => {
      if (timeDuration && video.duration) {
        timeDuration.textContent = formatTime(video.duration);
      }
    });

    video.addEventListener('durationchange', () => {
      if (timeDuration && video.duration) {
        timeDuration.textContent = formatTime(video.duration);
      }
    });

    let isScrubbing = false;

    video.addEventListener('timeupdate', () => {
      if (timeCurrent) timeCurrent.textContent = formatTime(video.currentTime);
      if (video.duration && !isScrubbing) {
        const pct = (video.currentTime / video.duration) * 100;
        if (progressFill) progressFill.style.width = pct + '%';
        if (progressThumb) progressThumb.style.left = pct + '%';
      }
    });

    // Scrubber click & drag seeking
    function seek(e) {
      if (!scrubber || !video.duration) return;
      const rect = scrubber.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const pos = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      const targetTime = pos * video.duration;
      if (progressFill) progressFill.style.width = (pos * 100) + '%';
      if (progressThumb) progressThumb.style.left = (pos * 100) + '%';
      if (timeCurrent) timeCurrent.textContent = formatTime(targetTime);
      return targetTime;
    }

    if (scrubber) {
      scrubber.addEventListener('mousedown', (e) => {
        isScrubbing = true;
        scrubber.classList.add('is-scrubbing');
        const t = seek(e);
        if (typeof t === 'number') video.currentTime = t;

        function onMouseMove(moveEvent) {
          if (!isScrubbing) return;
          const newTime = seek(moveEvent);
          if (typeof newTime === 'number') video.currentTime = newTime;
        }

        function onMouseUp() {
          isScrubbing = false;
          scrubber.classList.remove('is-scrubbing');
          window.removeEventListener('mousemove', onMouseMove);
          window.removeEventListener('mouseup', onMouseUp);
        }

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      });

      scrubber.addEventListener('touchstart', (e) => {
        isScrubbing = true;
        scrubber.classList.add('is-scrubbing');
        const t = seek(e);
        if (typeof t === 'number') video.currentTime = t;
      }, { passive: true });

      scrubber.addEventListener('touchmove', (e) => {
        if (!isScrubbing) return;
        const newTime = seek(e);
        if (typeof newTime === 'number') video.currentTime = newTime;
      }, { passive: true });

      scrubber.addEventListener('touchend', () => {
        isScrubbing = false;
        scrubber.classList.remove('is-scrubbing');
      });
    }

    // Volume & Mute toggle
    if (volumeBtn) {
      volumeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (video.muted || video.volume === 0) {
          video.muted = false;
          if (video.volume === 0) video.volume = 1;
        } else {
          video.muted = true;
        }
      });
    }

    video.addEventListener('volumechange', () => {
      if (video.muted || video.volume === 0) {
        container.classList.add('is-muted');
      } else {
        container.classList.remove('is-muted');
      }
    });

    if (video.muted || video.volume === 0) {
      container.classList.add('is-muted');
    }

    // Fullscreen toggle
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
        if (!isFullscreen) {
          if (container.requestFullscreen) {
            container.requestFullscreen();
          } else if (container.webkitRequestFullscreen) {
            container.webkitRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        }
      });
    }

    function onFullscreenChange() {
      const isFs = !!(document.fullscreenElement || document.webkitFullscreenElement);
      container.classList.toggle('is-fullscreen', isFs);
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);

    // Auto-hide controls when playing and idle
    let idleTimer = null;
    function resetIdleTimer() {
      container.classList.remove('controls-hidden');
      clearTimeout(idleTimer);
      if (!video.paused && !video.ended) {
        idleTimer = setTimeout(() => {
          container.classList.add('controls-hidden');
        }, 2500);
      }
    }

    container.addEventListener('mousemove', resetIdleTimer);
    container.addEventListener('touchstart', resetIdleTimer, { passive: true });

    // Keyboard support when focused
    container.setAttribute('tabindex', '0');
    container.addEventListener('keydown', (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === ' ' || e.key === 'k') {
        e.preventDefault();
        togglePlay();
      } else if (e.key === 'f') {
        e.preventDefault();
        if (fullscreenBtn) fullscreenBtn.click();
      } else if (e.key === 'm') {
        e.preventDefault();
        if (volumeBtn) volumeBtn.click();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        video.currentTime = Math.min(video.duration, video.currentTime + 5);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        video.currentTime = Math.max(0, video.currentTime - 5);
      }
    });

    // Initialize initial time display
    if (video.duration) {
      if (timeDuration) timeDuration.textContent = formatTime(video.duration);
    }
  }

  function initFilterGrid(root) {
    const buttons = [...root.querySelectorAll('[data-welcome-filter]')];
    const cards = [...root.querySelectorAll('[data-welcome-card]')];
    if (!buttons.length) return;
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.welcomeFilter;
        buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
        cards.forEach((card) => {
          const cat = card.dataset.category || 'all';
          const show = filter === 'all' || cat === filter;
          card.hidden = !show;
        });
      });
    });
  }

  function initWelcomeVideoModal(root) {
    const modal = root.querySelector('[data-welcome-modal]');
    if (!modal) return;

    const playerSlot = modal.querySelector('[data-modal-player-slot]');
    const tagEl = modal.querySelector('[data-modal-tag]');
    const durationEl = modal.querySelector('[data-modal-duration]');
    const titleEl = modal.querySelector('[data-modal-title]');
    const descEl = modal.querySelector('[data-modal-desc]');
    const closeBtns = modal.querySelectorAll('[data-modal-close]');

    let activeVideo = null;
    let lastFocusedElement = null;

    function closeModal() {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      if (activeVideo) {
        try {
          activeVideo.pause();
        } catch (e) {}
        activeVideo = null;
      }
      if (playerSlot) {
        playerSlot.innerHTML = '';
      }
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function openModal(cardId, triggerEl) {
      const template = document.getElementById(`video-payload-${cardId}`);
      if (!template || !playerSlot) return;

      lastFocusedElement = triggerEl || document.activeElement;

      const content = template.content.cloneNode(true);
      const wrapper = content.querySelector('[data-modal-video-card]');
      if (!wrapper) return;

      const title = wrapper.dataset.title || '';
      const category = wrapper.dataset.category || '';
      const description = wrapper.dataset.description || '';
      const duration = wrapper.dataset.duration || '';

      if (titleEl) titleEl.textContent = title;
      if (tagEl) tagEl.textContent = category;
      if (durationEl) durationEl.textContent = duration;
      if (descEl) descEl.textContent = description;

      playerSlot.innerHTML = '';
      playerSlot.appendChild(content);

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const video = playerSlot.querySelector('video');
      if (video) {
        activeVideo = video;
        video.play().catch(() => {});
      }

      const closeBtn = modal.querySelector('.becoming-welcome-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    const triggers = root.querySelectorAll('[data-welcome-video-trigger]');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const cardId = trigger.dataset.cardId;
        if (cardId) {
          openModal(cardId, trigger);
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-welcome-video-player]').forEach(initWelcomeVideoPlayer);
    document.querySelectorAll('[data-becoming-welcome]').forEach((root) => {
      initFilterGrid(root);
      initWelcomeVideoModal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const target = e.target;
    if (target) {
      target.querySelectorAll('[data-welcome-video-player]').forEach(initWelcomeVideoPlayer);
      target.querySelectorAll('[data-becoming-welcome]').forEach((root) => {
        initFilterGrid(root);
        initWelcomeVideoModal(root);
      });
    }
  });
})();
